module.exports = {
  "dof-row": {
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "overflow": "hidden"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-72388737!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-row/index.vue
// module id = 514
// module chunks = 0 1